module.exports = __webpack_public_path__ + "img/VL_15_03.e0bfee72.png";